import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Bell } from "lucide-react";
import { format, parseISO } from "date-fns";

export default function EmployeeNotifications() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/notifications").then(({ data }) => setItems(data));
  }, []);

  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    setItems(items.map(n => n.id === id ? { ...n, read: true } : n));
  };

  return (
    <div className="space-y-3 py-2">
      <div className="label-mono">Alerts</div>
      {items.length === 0 && <div className="text-sm text-muted-foreground text-center py-10">All caught up.</div>}
      {items.map(n => (
        <button
          key={n.id}
          onClick={() => markRead(n.id)}
          data-testid={`notif-${n.id}`}
          className={`w-full text-left border border-border p-4 flex items-start gap-3 ${n.read ? "opacity-60" : "bg-secondary/40"}`}
        >
          <Bell className="h-4 w-4 mt-0.5" strokeWidth={1.5} />
          <div className="flex-1">
            <div className="text-sm">{n.message}</div>
            <div className="label-mono mt-1">{format(parseISO(n.created_at), "d MMM · HH:mm")}</div>
          </div>
        </button>
      ))}
    </div>
  );
}
